export class MlpaJobColorcorrectionInfo {
  colorManagementSystemId: string;
  pressType: string;
  substrateWeight: string;
  printMode: string;
  inkColors: string;
  overPrintVarnish: string;
  speed: string;
}
